import { en } from './en';
import { es } from './es';
import { LanguageCode } from '../../types/language';

export const DEFAULT_LANG: LanguageCode = 'en';
export const AVAILABLE_LANGUAGES: LanguageCode[] = ['en', 'es'];

export const LANGUAGE_LABELS: Record<LanguageCode, string> = {
    en: 'English',
    es: 'Español',
};

export const translations: Record<LanguageCode, typeof en> = {
    en,
    es,
};
